<content>
  <form [formGroup]="deleteRolesForm" [ngClass]="{'show-error': showError}">
    <div class="entry-5">
      <label>{{'usuarios.general.modalDeleteRole.chooseRole' | translate}} *</label>
      <app-filterable-list [itemsList]="roles" [selectedItem]="deleteRolesForm.get('roleName')" [placeHolder]="false">
      </app-filterable-list>
    </div>
  </form>
</content>
<footer>
  <button class="secondary" (click)="closeDeleteRoleModal()">{{'global.cancelar' | translate}}</button>
  <button (click)="deleteUserRole()">{{'usuarios.general.modalDeleteRole.deleteRole' | translate}}</button>
</footer>
<app-toast *ngIf="showError && mensajes" [messages]="mensajes" (closed)="showError=$event"></app-toast>
